import script from "./CopilotSuggestButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./CopilotSuggestButton.vue?vue&type=script&lang=ts&setup=true"

import "./CopilotSuggestButton.vue?vue&type=style&index=0&id=437e51a8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-437e51a8"]])

export default __exports__